export default {
  methods: {
    // ページタイトルと説明を書き換え
    changePageContent() {
      document.title = this.jsonData.title + ' | ' + this.title;
      document.querySelector('meta[name="description"]').setAttribute('content', this.description);
      this.updateOgpContent();
    },

    // 特定のページにnoindex, nofollowのmetaタグを追加
    addNoIndexMeta() {
      const metaTag = document.createElement('meta');
      metaTag.name = 'robots';
      metaTag.content = 'noindex, nofollow';
      document.head.appendChild(metaTag);
    },

    // OGP関連のmeta contentを書き換え
    updateOgpContent() {
      if (this.title) {
        document.querySelector('meta[property="og:title"]').setAttribute('content', this.jsonData.title + ' | ' + this.title); // OGP:タイトル
      }
      if (this.description) {
        document.querySelector('meta[property="og:description"]').setAttribute('content', this.description); // OGP:説明文
      }
      // siteNameが設定されている場合はog:site_nameを書き換え
      if (this.siteName) {
        document.querySelector('meta[property="og:site_name"]').setAttribute('content', this.siteName); // OGP:サイト名
      } else {
        document.querySelector('meta[property="og:site_name"]').setAttribute('content', this.title); // OGP:サイト名
      }
      // og:urlを書き換え
      const currentUrl = window.location.href
      const baseUrl = currentUrl.split('?')[0]; // URLのパラメータを除外
      document.querySelector('meta[property="og:url"]').setAttribute('content', baseUrl); // OGP:URL

      // ogImagePathが設定されている場合はog:imageを書き換え
      try {
        if (typeof this.ogImagePath === 'function') {
          document.querySelector('meta[property="og:image"]').setAttribute('content', this.ogImagePath()); // OGP:画像
        } 
      } catch (error) {
        console.error('Error updating OGP IMAGE content:', error);
      }

      // 子ページの時はog:typeを"article"にする
      if (this.pageId !== undefined) {
        document.querySelector('meta[property="og:type"]').setAttribute('content', 'article'); // OGP:サイトの種類
      }
    },

    // 出現位置の設定
    setRoomRig(mainModelName, mainPageName) {
      // 直前の建物名を取得(パラメーターから抽出)
      let prevModel = '';
      if (this.prevPageId !== undefined) prevModel = this.prevPageId.replace(/[^a-z]/gi, '');

      // ページIDが存在しない場合メイン(office/event等)の処理を行う(親ページ)
      if (this.pageId === undefined) {
        // メイン(office/event等)の情報を設定
        this.jsonData = this.allJsonData[mainModelName];
        // エレベーターから戻ってきた場合の出現位置を設定
        if (this.prevPageId !== undefined) {
          // jsonのprevRigに子階層の設定がある場合
          const allowedKeys = ['comment', 'position', 'rotation'];  // 除外するキー
          // 除外キー以外のデータがあれば取得
          const unexpectedKeys = Object.keys(this.jsonData.prevRig).filter(
            key => !allowedKeys.includes(key)
          );
          // 除外キー以外の値が存在する場合
          if (unexpectedKeys.length > 0) {
            // 直前のページ名が設定されているかチェック
            if (unexpectedKeys.indexOf(this.prevPageId) !== -1) {
              this.jsonData.rig = this.jsonData.prevRig[this.prevPageId];
            // 直前の建物名が設定されているかチェック
            } else if (unexpectedKeys.indexOf(prevModel) !== -1) {
              this.jsonData.rig = this.jsonData.prevRig[prevModel];
            }
          // 除外キー以外の値が存在しない場合
          } else {
            if (Object.keys(this.jsonData.prevRig).length > 0) this.jsonData.rig = this.jsonData.prevRig;
          }
        }
      } else if (this.allJsonData[this.pageId] === undefined) {
        // ページが存在しない場合はメインフロアを表示
        this.jsonData = this.allJsonData[mainModelName];
        this.$router.push({ name: mainPageName });
        setTimeout(function () {
          location.reload();
        }, 10);

      // ページIDが存在する場合情報を上書き(子階層ページ)
      } else {
        // ルートパスを上書き
        this.routePath = this.secondaryRoutePath;
        // ページ情報を設定
        this.jsonData = this.allJsonData[this.pageId];
        // ページidから数字を抽出
        let prevNum = 0;
        let pageNum = this.pageId.replace(/[^0-9]/gi, '');  // 現在ページのNoを抽出
        if (this.prevPageId !== undefined) prevNum = this.prevPageId.replace(/[^0-9]/gi, ''); // 1つ前のページのNoを抽出
        // ページ番号が設定されている場合
        if (prevNum !== '') {
          // prevが現在のページより大きい数の場合rigを上書き
          if (pageNum < prevNum) {
            // 前のページから戻ってきた場合
            console.log(this.jsonData.prevRig)
            this.jsonData.rig = this.jsonData.prevRig;
          }
        // 番号なしのprevPageIdが設定されている場合
        } else if (this.prevPageId !== '') {
          // this.jsonData.rig = this.jsonData.prevRig;
          if (this.jsonData.prevRig) {
             // 現在ページのデータに、前のページから戻った際のリグ位置が設定されている場合
            if (this.jsonData.prevRig[this.prevPageId]) {
              // prevRigに「前のページID」がキーとして存在していれば、対応するリグを使う
              this.jsonData.rig = this.jsonData.prevRig[this.prevPageId];
            } else if (this.jsonData.prevRig[prevModel]) {
              // prevModelがキーとして存在すれば、そのリグを使う
              this.jsonData.rig = this.jsonData.prevRig[prevModel];
            } else {
              // 上記いずれにも一致しない場合は、prevRig全体をそのまま使う
              this.jsonData.rig = this.jsonData.prevRig;
            }
          }
        }
      }
      // // カメラ座標を設定
      // this.jsonData['camera'] = this.camera;
    }
  }
}